import MoenyIcon from "@/assets/SVG/MoneyIcon";
import NewUsersIcon from "@/assets/SVG/newUsersIcon";
import PatientIcon from "@/assets/SVG/PatientIcon";
import SurgeryIcon from "@/assets/SVG/SurgeryIcon";
import TripIcon from "@/assets/SVG/TripIcon";
import TripIcon24 from "@/assets/SVG/TripIcon24";
import ActiveArea from "@/pages/admin/dashboard/components/ActiveArea";
import Card from "@/pages/admin/dashboard/components/Card";
import { Button, Grid, Tab, Tabs, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateTripPop from "../createTripPop";
import CustomTable from "../../../components/customTable/CustomTable";
import { Modal } from "../../../components/modal";
import { getGroupAllTripsInfo, getGroupDashboard } from "@/api/group";
import Report from "./Report";
import { Loader } from "@/components";
import AllTripsInfo from "./AllTripsInfo";

const styleSelected = {
  fontSize: "16px !important",
  color: "white !important",
  backgroundColor: "var(--emr-darkblue) !important",
  cursor: "pointer",
  transition: "0.2s all",
  borderRadius: "8px !important",
  padding: "4px 8px !important",
};
const styleNotSelected = {
  fontSize: "14px !important",
  color: "var(--emr-disable) !important",
  cursor: "pointer",
  transition: "0.2s all !important",
};

export default function DashboardGroup({ data, leader }) {
  const navigate = useNavigate();

  const [tripDigest, setTripDigest] = useState();
  const [selectedProject, setSelectedProject] = useState();
  const [activeTripsStats, setActiveTripsStats] = useState([]);
  const [allTripsInfo, setAllTripsInfo] = useState();
  const [loading, setLoading] = useState(false);

  const [dataViewGroupInfo, colDefs] = useMemo(
    () => [
      [
        {
          title: "مراجعین",
          count: data?.postRef,
          icon: <PatientIcon />,
          unit: "بیمار",
        },
        {
          title: "مراجعین پس از اردو",
          count: data?.totalRefs,
          icon: <PatientIcon />,
          unit: "بیمار",
        },
        {
          title: "جهادگران",
          count: data?.members,
          icon: <NewUsersIcon />,
          navigate: () => navigate("/users_trip"),
          unit: "نفر",
        },
        {
          title: "هزینه خدمات",
          count: data?.totalCosts,
          icon: <MoenyIcon />,
          unit: "ریال",
        },
        {
          title: "جراحی‌ها",
          count: data?.surgeries,
          icon: <SurgeryIcon />,
          unit: "جراحی",
        },
      ],
      [
        {
          field: "name",
          headerName: "نام",
          width: 150,
        },
        {
          headerName: "بازه",
          width: 200,
          cellRenderer: (x) => {
            return (
              <Typography
                key={`date_${x.id}`}
                fontFamily="Vazirmatn"
                sx={{ lineHeight: "unset" }}
              >
                {x.data?.startAt + " - " + x.data?.endAt}
              </Typography>
            );
          },
        },
        {
          headerName: "تعداد اردوها",
          width: 120,
          cellRenderer: (x) => {
            return (
              <Typography
                key={`date_${x.id}`}
                fontFamily="Vazirmatn"
                sx={{ lineHeight: "unset" }}
              >
                {x.data?.tripDigests.length}
              </Typography>
            );
          },
        },
        {
          field: "createdAt",
          headerName: "زمان ایجاد",
          width: 150,
        },
        {
          headerName: "عملیات",
          width: 500,
          cellRenderer: (x) => {
            return (
              <Grid
                key={`op_${x.id}`}
                display={"flex"}
                flexDirection={"row"}
                alignContent={"center"}
                gap={"10px"}
              >
                {leader &&
                  x.data.tripDigests.map((tripDigest, index) => (
                    <Button
                      key={`trip_${index}`}
                      variant="contained"
                      sx={{ fontFamily: "Vazirmatn", fontSize: "11px" }}
                      onClick={() => {
                        setTripDigest(tripDigest);
                        setSelectedProject(x.data);
                      }}
                    >
                      {`ساخت اردو - ${index + 1}`}
                    </Button>
                  ))}
              </Grid>
            );
          },
        },
      ],
    ],
    [data],
  );

  useEffect(() => {
    getGroupDashboard().then((res) => {
      // setTrips(res.trips);

      if (res.activeCartable) {
        if (
          res.activeCartable.activeTrips &&
          res.activeCartable.activeTrips.length > 0
        )
          setActiveTripsStats(res.activeCartable.activeTrips);
      }
    });
  }, []);

  const [selectedTab, setSelectedTab] = useState("group");

  const fetchAllTripsInfo = useCallback(() => {
    setLoading(true);
    getGroupAllTripsInfo()
      .then((res) => setAllTripsInfo(res))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (selectedTab !== "allTripsInfo" || allTripsInfo) return;
    fetchAllTripsInfo();
  }, [selectedTab]);

  return (
    <>
      <Tabs
        value={selectedTab}
        onChange={(_, newValue) => {
          setSelectedTab(newValue);
        }}
        sx={{
          backgroundColor: "var(--emr-background-silver)",
          padding: "6px 12px",
          borderRadius: "8px",
          overflow: "auto",
          mt: "10px",
          "& .MuiTabs-indicator": {
            bgcolor: "white",
          },
          "& .MuiTabs-flexContainer": {
            overflow: "auto",
          },
        }}
      >
        <Tab
          label="اطلاعات شخصی"
          value={"group"}
          sx={selectedTab === "group" ? styleSelected : styleNotSelected}
          onClick={() => setSelectedTab("group")}
        />
        <Tab
          label="رصد کل اردوها"
          value={"allTripsInfo"}
          sx={selectedTab === "allTripsInfo" ? styleSelected : styleNotSelected}
          onClick={() => setSelectedTab("allTripsInfo")}
        />
        <Tab
          label="رصد اردوهای جاری"
          value={"report"}
          sx={selectedTab === "report" ? styleSelected : styleNotSelected}
          onClick={() => setSelectedTab("report")}
        />
      </Tabs>
      {loading && <Loader />}

      {selectedTab === "report" && (
        <Report activeTripsStats={activeTripsStats} />
      )}

      {selectedTab === "allTripsInfo" && allTripsInfo && (
        <AllTripsInfo allTripsInfo={allTripsInfo} />
      )}

      {tripDigest && (
        <CreateTripPop
          selectedProject={selectedProject}
          onClose={() => setTripDigest(undefined)}
          tripDigest={tripDigest}
        />
      )}

      {!tripDigest && (
        <Grid gap="30px" display={"flex"} flexDirection={"column"}>
          {leader && data?.activeProjects.length >= 1 && (
            <>
              <Modal title={"پروژه‌های فعال"} icon={<TripIcon24 />}>
                <CustomTable
                  columns={colDefs}
                  rowData={data?.activeProjects}
                  needPagination={false}
                />
              </Modal>
            </>
          )}
          <Grid
            gap="15px"
            display={"flex"}
            flexDirection={"row"}
            flexWrap="wrap"
          >
            {dataViewGroupInfo.map((item) => (
              <Card
                icon={item.icon}
                title={item.title}
                counter={item.count}
                unit={item.unit}
                onClick={item.navigate}
              />
            ))}
          </Grid>
          <Modal
            title={"اردوهای جاری"}
            icon={<TripIcon />}
            titleVariant="body1"
            background={
              "linear-gradient(90deg, rgba(20, 184, 166, 0.41) 0%, rgba(255, 255, 255) 10%)"
            }
          >
            <Grid
              display={"flex"}
              flexDirection={"row"}
              gap={"10px"}
              flexWrap={"nowrap"}
              mt={"20px"}
              overflow={"auto"}
            >
              {data?.activeTrips.length >= 1 &&
                data?.activeTrips?.map((item, index) => (
                  <ActiveArea key={index} areaInfo={item} />
                ))}
            </Grid>
          </Modal>
        </Grid>
      )}
    </>
  );
}
